module.exports = __webpack_public_path__ + "static/media/tsb11ru.48fadb52.pdf";